import { get, post } from '@eika-infrastruktur/request';

import { AccountId, BookedTransactions, Loan, LoanAccount, PendingTransaction } from '../generated-types';

export const CONTEXT_PATH = '/kredittbank-kredittbanken-web';
export const SERVICE_PATH = 'rest/resource/loans';

export const getLoans = async () => get<Loan[]>(`${CONTEXT_PATH}/${SERVICE_PATH}`);

export const getLoanDetails = async (accountId: AccountId) =>
    get<LoanAccount>(`${CONTEXT_PATH}/${SERVICE_PATH}/${accountId}`);

export const getPendingTransactions = async (accountId: AccountId) =>
    get<PendingTransaction[]>(`${CONTEXT_PATH}/${SERVICE_PATH}/${accountId}/pending`);

export const getBookedTransactions = async (accountId: AccountId, nextReference: number) =>
    post<BookedTransactions>(`${CONTEXT_PATH}/${SERVICE_PATH}/${accountId}/booked`, { nextReference });
